import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronLeft, ShoppingCart, User } from 'lucide-react';
import { useBrandConfig } from '../../../context/BrandConfigContext';

/**
 * Global reusable centered-logo header for the "magic" template — keeps logo/branding,
 * back navigation and the cart/profile shortcuts consistent across every magic page
 * (wizard steps, FAQ, T&Cs, Profile, Cart) instead of each page rolling its own header.
 * Props:
 *  - variant: 'dark' (red bg, white logo/icons — wizard steps) | 'light' (white bg, red logo/dark icons — content pages)
 *  - showBack / onBack: optional back control on the left
 *  - hideActions: hide the cart/profile shortcuts (e.g. on the reveal step)
 */
const MagicHeader = ({ variant = 'dark', showBack = false, onBack, hideActions = false } = {}) => {
  const brand = useBrandConfig();
  const isLight = variant === 'light';
  const logoSrc = isLight
    ? '/assets/images/app-logo/coca-cola-red.svg'
    : brand?.logoUrl || '/assets/images/app-logo/coca-cola-white.png';

  return (
    <header className={`header strict-width py-2 mx-auto magic-header magic-header--${variant}`}>
      <div className="header-content">
        <div className="left-content">
          {showBack && (
            <button type="button" className="magic-header-icon-btn" onClick={onBack} aria-label="Back">
              <ChevronLeft size={22} />
            </button>
          )}
        </div>
        <div className="mid-content">
          <img src={logoSrc} width={80} alt="App Logo" className="app-logo" />
        </div>
        <div className="right-content d-flex align-items-center gap-3">
          {!hideActions && (
            <>
              <Link to="/cart" className="magic-header-icon-btn" aria-label="Cart">
                <ShoppingCart size={20} />
              </Link>
              <Link to="/profile" className="magic-header-icon-btn" aria-label="Profile">
                <User size={20} />
              </Link>
            </>
          )}
        </div>
      </div>
    </header>
  );
};

export default MagicHeader;
